import React from "react";
export const YouTube: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		<g
			id="d_0.0_Home_Screen_fullPG"
			transform="translate(-1145.000000, -66.000000)"
			fill="#374B5A"
			fillRule="nonzero"
		>
			<g id="d_NAV_MAIN" transform="translate(1.000000, 0.000000)">
				<g id="ICONs_4_alt" transform="translate(1100.000000, 62.000000)">
					<g id="YT-Copy" transform="translate(44.607701, 0.000000)">
						<path d="M6.43789161,26 C2.88298867,26 6.18882723e-12,23.1092068 6.18882723e-12,19.5429002 L6.18882723e-12,10.4570952 C6.18882723e-12,6.89194158 2.88298867,4 6.43789161,4 L23.519043,4 C27.0749482,4 29.9580458,6.89194158 29.9580458,10.4570952 L29.9580458,19.5429002 C29.9580458,23.1092068 27.0749482,26 23.519043,26 L6.43789161,26 Z M10.7887783,10.8263015 L10.7887783,19.1888407 C10.7887783,19.4404154 11.0503327,19.6058007 11.2758243,19.4974833 L19.752721,15.4420006 C20.0071531,15.3208704 20.0119373,14.9586586 19.7596235,14.8305358 L11.2829492,10.5223174 C11.2327522,10.4966788 11.1804421,10.4849158 11.1294663,10.4849158 C10.9511651,10.4849158 10.7887783,10.6288509 10.7887783,10.8263015 Z"></path>
					</g>
				</g>
			</g>
		</g>
	</g>
);
